// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__13ReE","form_user":"styles_form_user__JRU9W","loader":"styles_loader__3jv1H"};